/* eslint-disable no-undef */

export default {
	name: "confirmation-modal",
	props: ["elementId", "heading", "message", "showModal", "loading"],
	emits: ["actionConfirmed"],
	data() {
		return {
		};
	},
	methods: {
		onYesClick(){
			this.$emit("actionConfirmed", true);
		},
		onNoClick(){
			this.$emit("actionConfirmed", false);
		}
	},
	mounted: function () {
        
	},
	watch: {
		showModal: {
			handler: function () {
				if (this.showModal) {
					$("#" + this.elementId).modal("show");
				}
				else{
					$("#" + this.elementId).modal("hide");
				}
			}
		}
	}
};
